import { render } from "./ProductWidget.vue?vue&type=template&id=5657b13c&scoped=true"
import script from "./ProductWidget.vue?vue&type=script&lang=js"
export * from "./ProductWidget.vue?vue&type=script&lang=js"

import "./ProductWidget.vue?vue&type=style&index=0&id=5657b13c&lang=scss"
import "./ProductWidget.vue?vue&type=style&index=1&id=5657b13c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5657b13c"]])

export default __exports__